import {
  CourseEntity,
  Enum_Favorite_Type,
  InsightEntity,
  PodcastEntity,
  ResourceEntity,
} from '@/graphql/generated/graphql';

import FavoriteButton from '../Favorite/FavoriteButton';
import LikeButton from '../LikeButton';

type TitleWithActionsProps = {
  title: string;
  entity: ResourceEntity | PodcastEntity | InsightEntity | CourseEntity;
  entityId: string;
  like?: boolean;
  favorite?: boolean;
  type: Enum_Favorite_Type;
};

export default function TitleWithActions({
  title,
  like = true,
  favorite = true,
  entity,
  entityId,
  type,
}: TitleWithActionsProps) {
  return (
    <div className="flex items-start justify-between gap-2">
      <h1 className="font-larken text-sh-36-48">{title}</h1>
      <div className="mt-sh-15 flex gap-sh-15">
        <div className="flex items-center justify-center">
          {title && like && <LikeButton entityId={entityId} type={type} />}
        </div>
        <div>{title && favorite && <FavoriteButton relationId={entityId || ''} metadata={entity!} type={type} />}</div>
      </div>
    </div>
  );
}
